import { ICopyable } from '../controls/common/icopyable';
import { Rights } from './enums/rights';
import { IRole } from './interfaces/role.interface';

export class Role implements ICopyable<Role> {
    public id: number = null;
    public name: string = null;
    public organizationId: string = null;
    public rights: Rights[] = [];

    public createCopy(): Role {
        const instance = new Role();
        instance.id = this.id;
        instance.name = this.name;
        instance.organizationId = this.organizationId;
        instance.rights = this.rights;
        return instance;
    }

    public static createFormCopy(role: Role): IRole {
        const instance = new Role();
        instance.id = role.id;
        instance.name = role.name;
        instance.organizationId = role.organizationId;
        instance.rights = role.rights;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.organizationId = other.organizationId;
        this.rights = other.rights;
    }

    /**
     * Retourne une instance de Authenticate à partir d'une instance de IAuthenticate.
     * @param other : Instance de IAuthenticate.
     * @returns : Instance de Authenticate.
     */
    public static from(other: IRole) {
        if (!!other) {
            const instance = new Role();

            instance.id = other.id;
            instance.name = other.name;
            instance.organizationId = other.organizationId;
            instance.rights = other.rights;

            return instance;
        } else {
            return null;
        }
    }

    public isCustom() {
        return !!this.organizationId;
    }

    public getDisplayName() {
        return `${this.name}`;
    }
}
